<script>
export default {
  name: "CardStatisticsForDirectorCampus"
}
</script>

<template>
  <v-row>
    <v-col md="4" cols="12">
      <v-card rounded="xl" outlined>
        <v-card-text class="d-flex justify-space-between">
          <div>
            <span class="text-subtitle-1">Подтвержденные заявления</span>
            <div class="d-flex align-center">
              <h6 class="text-h5 font-weight-bold green--text">{{ 0 }}</h6>
            </div>
            <span class="text-sm">Количество одобренных заявлений</span>
          </div>
          <div>
            <v-avatar
                color="green lighten-4"
                rounded
                size="53"
            >
              <v-icon color="green">fa-user-check</v-icon>
            </v-avatar>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col md="4" cols="12">
      <v-card rounded="xl" outlined>
        <v-card-text class="d-flex justify-space-between">
          <div>
            <span class="text-subtitle-1">Отклоненные заявления</span>
            <div class="d-flex align-center">
              <h6 class="text-h5 font-weight-bold red--text">{{ 0 }}</h6>
            </div>
            <span class="text-sm">Количество неодобренных заявлений</span>
          </div>
          <div>
            <v-avatar
                color="red lighten-4"
                rounded
                size="53"
            >
              <v-icon color="red">fa fa-user-times</v-icon>
            </v-avatar>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col md="4" cols="12">
      <v-card rounded="xl" outlined>
        <v-card-text class="d-flex justify-space-between">
          <div>
            <span class="text-subtitle-1">Рассматриваемые заявления</span>
            <div class="d-flex align-center">
              <h6 class="text-h5 font-weight-bold orange--text">{{ 0 }}</h6>
            </div>
            <span class="text-sm">Количество рассматриваемых заявлений</span>
          </div>
          <div>
            <v-avatar
                color="orange lighten-4"
                rounded
                size="53"
            >
              <v-icon color="orange">fa-user-clock</v-icon>
            </v-avatar>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<style scoped>

</style>